import React from 'react';
import {Text, TextPriority} from '@wix/wix-ui-tpa/cssVars';
import {useControllerProps} from '../../Widget/ControllerContext';
import {classes} from './RecurringPaymentInfo.st.css';

export enum RecurringPaymentInfoDataHooks {
  root = 'RecurringPaymentInfoDataHooks.root',
  title = 'RecurringPaymentInfoDataHooks.title',
  chargeDescription = 'RecurringPaymentInfoDataHooks.chargeDescription',
}

export const RecurringPaymentInfo = () => {
  const {
    paymentRequestStore: {paymentRequest},
  } = useControllerProps();

  const subscriptionInfoWithDescription = paymentRequest.subscriptionInfo.filter((info) =>
    Boolean(info.chargeDescription)
  );

  if (subscriptionInfoWithDescription.length === 0) {
    return null;
  }

  return (
    <div className={classes.root} data-hook={RecurringPaymentInfoDataHooks.root}>
      <div>
        <Text className={classes.title} data-hook={RecurringPaymentInfoDataHooks.title}>
          *** Recurring Payment ***
        </Text>
      </div>
      {subscriptionInfoWithDescription.map((info, index) => (
        <div key={index}>
          <Text
            className={classes.chargeDescription}
            priority={TextPriority.secondary}
            data-hook={RecurringPaymentInfoDataHooks.chargeDescription}>
            {info.chargeDescription}
          </Text>
        </div>
      ))}
    </div>
  );
};
